/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15.7033 9C15.7033 7.34315 14.3767 6 12.7403 6H11.2589C9.62246 6 8.2959 7.34315 8.2959 9C8.2959 9.25897 8.32831 9.51029 8.38924 9.75"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.7406 12H11.2591H6M12.7406 12C14.377 12 15.7035 13.3431 15.7035 15C15.7035 16.6569 14.377 18 12.7406 18H11.2591C9.62268 18 8.29612 16.6569 8.29612 15M12.7406 12H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12.7406 12H11.2591H6M12.7406 12C14.377 12 15.7035 13.3431 15.7035 15C15.7035 16.6569 14.377 18 12.7406 18H11.2591C9.62268 18 8.29612 16.6569 8.29612 15M12.7406 12H18M15.7035 9C15.7035 7.34315 14.377 6 12.7406 6H11.2591C9.62268 6 8.29612 7.34315 8.29612 9C8.29612 9.25897 8.32853 9.51029 8.38946 9.75M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM11.2591 5.25C9.19971 5.25 7.54612 6.93774 7.54612 9C7.54612 9.32176 7.58641 9.63513 7.66258 9.93478C7.76463 10.3362 8.17279 10.5789 8.57424 10.4769C8.97568 10.3748 9.21839 9.96667 9.11634 9.56522C9.07064 9.38544 9.04612 9.19619 9.04612 9C9.04612 7.74855 10.0456 6.75 11.2591 6.75H12.7406C13.954 6.75 14.9535 7.74855 14.9535 9C14.9535 9.41421 15.2893 9.75 15.7035 9.75C16.1177 9.75 16.4535 9.41421 16.4535 9C16.4535 6.93774 14.7999 5.25 12.7406 5.25H11.2591ZM6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H11.2591H12.7406C13.954 12.75 14.9535 13.7485 14.9535 15C14.9535 16.2515 13.954 17.25 12.7406 17.25H11.2591C10.0456 17.25 9.04612 16.2515 9.04612 15C9.04612 14.5858 8.71033 14.25 8.29612 14.25C7.8819 14.25 7.54612 14.5858 7.54612 15C7.54612 17.0623 9.19971 18.75 11.2591 18.75H12.7406C14.7999 18.75 16.4535 17.0623 16.4535 15C16.4535 14.1577 16.1777 13.3779 15.711 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H12.7406H11.2591H6Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M12.7406 12H11.2591H6M12.7406 12C14.377 12 15.7035 13.3431 15.7035 15C15.7035 16.6569 14.377 18 12.7406 18H11.2591C9.62268 18 8.29612 16.6569 8.29612 15M12.7406 12H18M15.7035 9C15.7035 7.34315 14.377 6 12.7406 6H11.2591C9.62268 6 8.29612 7.34315 8.29612 9C8.29612 9.25897 8.32853 9.51029 8.38946 9.75"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.7406 12H11.2591H6M12.7406 12C14.377 12 15.7035 13.3431 15.7035 15C15.7035 16.6569 14.377 18 12.7406 18H11.2591C9.62268 18 8.29612 16.6569 8.29612 15M12.7406 12H18M15.7035 9C15.7035 7.34315 14.377 6 12.7406 6H11.2591C9.62268 6 8.29612 7.34315 8.29612 9C8.29612 9.25897 8.32853 9.51029 8.38946 9.75M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.54612 9C7.54612 6.93774 9.19971 5.25 11.2591 5.25H12.7406C14.7999 5.25 16.4535 6.93774 16.4535 9C16.4535 9.41421 16.1177 9.75 15.7035 9.75C15.2893 9.75 14.9535 9.41421 14.9535 9C14.9535 7.74855 13.954 6.75 12.7406 6.75H11.2591C10.0456 6.75 9.04612 7.74855 9.04612 9C9.04612 9.19619 9.07064 9.38544 9.11634 9.56522C9.21839 9.96667 8.97568 10.3748 8.57424 10.4769C8.17279 10.5789 7.76463 10.3362 7.66258 9.93478C7.58641 9.63513 7.54612 9.32176 7.54612 9ZM5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H11.2591H12.7406H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H15.711C16.1777 13.3779 16.4535 14.1577 16.4535 15C16.4535 17.0623 14.7999 18.75 12.7406 18.75H11.2591C9.19971 18.75 7.54612 17.0623 7.54612 15C7.54612 14.5858 7.8819 14.25 8.29612 14.25C8.71033 14.25 9.04612 14.5858 9.04612 15C9.04612 16.2515 10.0456 17.25 11.2591 17.25H12.7406C13.954 17.25 14.9535 16.2515 14.9535 15C14.9535 13.7485 13.954 12.75 12.7406 12.75H11.2591H6C5.58579 12.75 5.25 12.4142 5.25 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
